import { useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { SchedulerConfigListViewModel, toSchedulerConfigListViewModel } from '../model';
import { nylasCalendarManageConnectionModalClient } from './client';

export const useGetSchedulerConfigQuery = () => {
  return useQuery({
    queryKey: [QueryKey.useGetSchedulerConfigQuery],
    queryFn: async (): Promise<SchedulerConfigListViewModel> => {
      const { data } = await nylasCalendarManageConnectionModalClient.getSchedulerConfigs();

      return toSchedulerConfigListViewModel(data);
    },
  });
};
